import { CheckboxProps as Mui5CheckboxProps } from '@mui/material/Checkbox'

import { FC } from 'react'
import { FormControlLabel } from '../form'
import { StyledHelperText } from '../other/common/StyledHelperText'
import { styled } from '../styles'
import { Checkbox } from './CheckBox'

const StyledRadioWrapper = styled('span')<Checkbox3Props>(({ theme, size, color }) => ({
  display: 'flex',
  flexDirection: 'column',
}))

export type Checkbox3Props = Omit<Mui5CheckboxProps, 'icon' | 'checkedIcon'> & {
  helperText?: string
}

export const Checkbox3: FC<Checkbox3Props> = (props) => {
  let { color, title, id, value, helperText, ...rest } = props
  return (
    <StyledRadioWrapper>
      <FormControlLabel
        label={title}
        key={id}
        value={value}
        control={
          <Checkbox
            sx={{ padding: 0, marginRight: '8px' }} // Customize padding and margin to fit new design with label
            color={color || 'primary'}
            {...rest}
          />
        }
      />
      {helperText && <StyledHelperText color={color || 'primary'}>{helperText}</StyledHelperText>}
    </StyledRadioWrapper>
  )
}
